import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import TermsOfService from "@/pages/TermsOfService";

export const Route = createFileRoute("/terms")({
  component: TermsOfService,
  head: () =>
    pageHead({
      title: "Terms of Service | jaik",
      description: "Terms of Service for jaik web design services. Payments, subscriptions, refunds, intellectual property, and dispute resolution.",
      path: "/terms",
    }),
});
